import { ReactNode } from 'react'
import clsx from 'clsx'
import Image from 'next/image'

import FormattedText from 'shared/ui/FormattedText'

import { PageTitle, SectionContainer } from '../../components/landings/styles'

import styles from './PaymentMethods.module.scss'

export interface PaymentMethodsTexts {
  header: string
  description: string | ReactNode
  image: {
    src: string
    alt: string
  }
  steps: {
    title: string
    description: string | ReactNode
    src: string
  }[]
  banks: {
    src: string
    alt: string
  }[]
}
interface PaymentMethodsProps {
  texts: PaymentMethodsTexts
}

const PaymentMethods = ({ texts }: PaymentMethodsProps) => {
  return (
    <SectionContainer $condensed>
      <PageTitle>
        <FormattedText text={texts.header} />
      </PageTitle>
      <div className={styles.pageDescription}>{texts.description}</div>
      <div className={styles.logoWrapper}>
        <Image
          src={texts.image.src}
          alt={texts.image.alt}
          width={286}
          height={100}
        />
      </div>
      <div className={styles.paymentsWrapper}>
        {texts.steps.map((step, index) => (
          <div key={index} className={styles.step}>
            <div className={styles.imageWrapper}>
              <Image
                fill
                style={{ objectFit: 'contain' }}
                src={step.src}
                alt={step.title}
              />
            </div>
            <h3 className={styles.stepTitle}>
              <FormattedText text={step.title} />
            </h3>
            <div className={styles.stepDescription}>{step.description}</div>
          </div>
        ))}
      </div>
      <div className={styles.banksWrapper}>
        {texts.banks.map((bank, index) => (
          <div key={index} className={clsx(styles.step, styles.centeredStep)}>
            <div className={styles.imageWrapper}>
              <Image
                fill
                src={bank.src}
                alt={bank.alt}
                style={{ objectFit: 'contain' }}
              />
            </div>
          </div>
        ))}
      </div>
    </SectionContainer>
  )
}

export default PaymentMethods
